import { Injectable } from '@angular/core';
import { ReponseCoordonneesCredit } from '../../api/model/reponse-coordonnees-credit.model';
import { AdressePhysiqueCredit } from '../../api/model/adresse-physique-credit.model';
import { TelephoneCredit } from '../../api/model/telephone-credit.model';

@Injectable({ providedIn: 'root' })
export class ReponseCoordonneesCreditService {
  reponseCoordonneesCredit: ReponseCoordonneesCredit | null = null;

  setReponseCoordonneesCredit(reponse: ReponseCoordonneesCredit) {
    this.reponseCoordonneesCredit = reponse;
  }

  getReponseCoordonneesCredit(): ReponseCoordonneesCredit | null {
    return this.reponseCoordonneesCredit;
  }

  estParticuliersCreditPlusQueUn(): boolean {
    return this.reponseCoordonneesCredit?.particulierCredit?.length > 1;
  }

  getAdresseCourante(): AdressePhysiqueCredit | null {
    return this.reponseCoordonneesCredit?.particulierCredit.find((p) => p?.adresseCourante)?.adresseCourante || null;
  }

  getAdresseCourriel(): string | null {
    return (
      this.reponseCoordonneesCredit?.particulierCredit.find((p) => p?.adresseCourriel?.adresseCourriel)?.adresseCourriel
        ?.adresseCourriel || null
    );
  }

  getTelephone(): TelephoneCredit | null {
    return this.reponseCoordonneesCredit?.particulierCredit
      ?.flatMap((p) => p?.telephones || [])
      .find((tel) => tel?.codeTypeUtilisationTelephone === 'RESIDENTIEL' && tel?.numeroTelephone);
  }
}
